// extracted by mini-css-extract-plugin
export var fileUpload = "_e8-1";
export var modalButton = "_e8-0";